import { LyraTheme as theme } from 'src/components/theme/lyra/Theme';
import { FormInputText, Props as InputProps } from '../forms/inputs/FormInputText';

export const LyraFormInputText = ({ ...props }: InputProps): JSX.Element => (
  <FormInputText
    {...props}
    sx={{
      '&.MuiOutlinedInput-root': {
        borderRadius: theme.spacing(1.5),
        background: 'white',
      },
      '.MuiOutlinedInput-notchedOutline': { borderColor: 'grey.900' },
      '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
        borderColor: 'grey.900',
      },
    }}
  />
);
